import { useNavigate } from "react-router-dom";
import ProfileAvatar from "components/common/ProfileAvatar";

/**
 * 강습/연습반/투어 화면에서 강사·수강생을 아바타+이름 형태로 노출하는 칩.
 * userId가 있으면 클릭 시 통합 프로필 (/instructor/:userId) 로 이동.
 */
const PersonChip = ({
    name,
    imageUrl,
    userId,
    size = 28,
    role,
    className = "",
}) => {
    const navigate = useNavigate();
    const clickable = !!userId;

    const handleClick = () => {
        if (!clickable) return;
        navigate(`/community/user/${encodeURIComponent(userId)}`);
    };

    return (
        <span
            className={`person-chip${clickable ? " person-chip--clickable" : ""} ${className}`}
            onClick={handleClick}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={(e) => {
                if (!clickable) return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick();
                }
            }}
        >
            <ProfileAvatar imageUrl={imageUrl} size={size} />
            <span className="person-chip__name">{name}</span>
            {role && <span className="person-chip__role">{role}</span>}
        </span>
    );
};

export default PersonChip;
